import type { IComponentController } from "angular";

import type { StateService } from "@uirouter/angularjs";
import { includes, isNil } from "lodash";
import type { IProfileService } from "App/Modules/Auth";
import type { IProfile } from "App/Modules/Models";

export default class HeaderComponentController implements IComponentController {
    public static $inject: string[] = ["mmProfileService", "$state"];

    public profile: IProfile;

    public constructor(private readonly profileService: IProfileService, private readonly stateService: StateService) {}

    public $onInit() {
        this.profile = null;

        this.profileService.profileObservable().subscribe((profile: IProfile) => {
            this.profile = profile;
        });
    }

    public isNotShown() {
        const nonAuthPaths = [
            "about",
            "login",
            "requestPasswordReset",
            "confirmPasswordReset",
            "confirmUserVerification",
            "cancelUserVerification",
        ];
        return isNil(this.stateService.$current.name) || includes(nonAuthPaths, this.stateService.$current.name);
    }
}
